<template>
  <div class="container">
    <h5>{{ t('knownIngredientsTitle') }}</h5>
    <p>{{ t('knownIngredientsDescription') }}</p>
    <hr />
    <div class="row">
      <div class="col-sm">
        <!-- Product 1 Inputs -->
        <GenericInput
          :inputLabel="t('product1')"
          v-model.number="product1Weight"
          :conversionFactors="ConversionFactors.weight"
        />
        <FixedUnitInput
          :inputLabel="t('thc')"
          v-model.number="product1THC"
          :unit="t('percentTHC')"
        />
        <FixedUnitInput
          :inputLabel="t('cbd')"
          v-model.number="product1CBD"
          :unit="t('percentCBD')"
        />
         <!-- Product 2 Inputs -->
         <GenericInput
          :inputLabel="t('product2')"
          v-model.number="product2Weight"
          :conversionFactors="ConversionFactors.weight"
        />
        <FixedUnitInput
          :inputLabel="t('thc')"
          v-model.number="product2THC"
          :unit="t('percentTHC')"
        />
        <FixedUnitInput
          :inputLabel="t('cbd')"
          v-model.number="product2CBD"
          :unit="t('percentCBD')"
        />
        <!-- Product 3 Inputs -->
        <GenericInput
          :inputLabel="t('product3')"
          v-model.number="product3Weight"
          :conversionFactors="ConversionFactors.weight"
        />
        <FixedUnitInput
          :inputLabel="t('thc')"
          v-model.number="product3THC"
          :unit="t('percentTHC')"
        />
        <FixedUnitInput
          :inputLabel="t('cbd')"
          v-model.number="product3CBD"
          :unit="t('percentCBD')"
        />
        <!-- Product 4 Inputs -->
        <GenericInput
          :inputLabel="t('product4')"
          v-model.number="product4Weight"
          :conversionFactors="ConversionFactors.weight"
        />
        <FixedUnitInput
          :inputLabel="t('thc')"
          v-model.number="product4THC"
          :unit="t('percentTHC')"
        />
        <FixedUnitInput
          :inputLabel="t('cbd')"
          v-model.number="product4CBD"
          :unit="t('percentCBD')"
        />
      </div>
      <div class="col-sm">
        <GenericOutput
          :outputLabel="t('finalProduct')"
          :number="totalWeight"
          :conversionFactors="weight"
          :conversion-factors="ConversionFactors.weight"
          :showSplitter="false"
        />
        <FixedUnitOutput
          :outputLabel="t('totalTHC')"
          :number="totalTHC"
          :unit="t('percentTHC')"
        />
        <FixedUnitOutput
          :outputLabel="t('totalCBD')"
          :number="totalCBD"
          :unit="t('percentCBD')"
        />
        <FixedUnitOutput
          :outputLabel="t('thcToCbdRatio')"
          :number="thcToCbdRatio"
          :unit="t('cbdUnit')"
        />
      </div>
    </div>
  </div>
</template>

  
  <script>
  import { ref, computed, reactive } from 'vue';
  import { useI18n } from 'vue-i18n';
  import GenericInput from '../inputs/GenericInput.vue'; // Adjust import path
  import FixedUnitInput from '../inputs/FixedUnitInput.vue'; // Adjust import path
  import GenericOutput from '../inputs/GenericOutput.vue'; // Adjust import path
  import FixedUnitOutput from '../inputs/FixedUnitOutput.vue'; // Adjust import path
  import ConversionFactors from '../../utils/conversion_factors';
  
  export default {
    components: {
      GenericInput,
      FixedUnitInput,
      GenericOutput,
      FixedUnitOutput,
    },
    setup() {
      

      //defin the products in ref
        const product1Weight = ref(1);
        const product1THC = ref(1);
        const product1CBD = ref(1);
        const product2Weight = ref(0);
        const product2THC = ref(0);
        const product2CBD = ref(0);
        const product3Weight = ref(0);
        const product3THC = ref(0);
        const product3CBD = ref(0);
        const product4Weight = ref(0);
        const product4THC = ref(0);
        const product4CBD = ref(0);

        const { t } = useI18n();

        // Create a reactive object with a function
        const translations = reactive({
          t: (key) => t(key)
        })

  
      const totalWeight = computed(() => {
        return (
          product1Weight.value +
          product2Weight.value +
          product3Weight.value +
          product4Weight.value
        );
      });
  
      const totalTHC = computed(() => {
        const total = (
          product1Weight.value * product1THC.value +
          product2Weight.value * product2THC.value +
          product3Weight.value * product3THC.value +
          product4Weight.value * product4THC.value 
        );
        return total/totalWeight.value;
        
      });
  
      const totalCBD = computed(() => {
        const total = (
          product1Weight.value * product1CBD.value +
          product2Weight.value * product2CBD.value +
          product3Weight.value * product3CBD.value +
          product4Weight.value * product4CBD.value 
        );
        return total/totalWeight.value;
      });
  
      const thcToCbdRatio = computed(() => {
        return totalCBD.value / totalTHC.value;
      });
  
      return { totalWeight, totalTHC, totalCBD, thcToCbdRatio,ConversionFactors, product1Weight, product1THC, product1CBD, product2Weight, product2THC, product2CBD, product3Weight, product3THC, product3CBD, product4Weight, product4THC, product4CBD, t: translations.t };
    },
  };
  </script>
  